import { defineComponent as _defineComponent } from 'vue'
import {PropType} from "vue";
  import {OrderWorklogsDateEmployee} from "@/model/OrderWorklogs";
  import Worklog from "@/model/Worklog";
  import WorklogUtils from "@/WorklogUtils";
  import {MessageTypes} from "@/components/message-types";
  import {WorklogType} from "@/enums";
  import eventBus from "@/eventbus";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderWorklogsListDate',
  props: {
    items: {
      type: Array as PropType<Array<OrderWorklogsDateEmployee>>,
      default: () => new Array<OrderWorklogsDateEmployee>()
    }
  },
  setup(__props) {

const props = __props

  

  function edit(worklog: Worklog): void {
    eventBus.$emit(MessageTypes.UPDATE_WORKLOG, worklog);
  }

  function getIcon(worklogType: string): string {
    return WorklogUtils.getIcon(worklogType as WorklogType);
  }

  function hasAutomaticPause(item: OrderWorklogsDateEmployee): boolean {
    let hasAutomaticPause = false;

    if (item.worklogs) {
      hasAutomaticPause = WorklogUtils.hasAutomaticPause(item.worklogs);
    }

    return hasAutomaticPause;
  }

return { __sfc: true,props, edit, getIcon, hasAutomaticPause }
}

})